/* drl-offer-options — radio behavior + variant sync.
   On click: mark selected, mirror selection into hidden [name="id"] on
   the product form, dispatch change so Dawn's product-form.js can react. */
(function () {
  function selectOffer(offer) {
    var group = offer.closest('[data-drl-offers]');
    if (!group) return;

    group.querySelectorAll('[data-drl-offer]').forEach(function (el) {
      var isMe = el === offer;
      el.classList.toggle('drl-offer--selected', isMe);
      el.setAttribute('aria-pressed', isMe ? 'true' : 'false');
    });

    var variantId = offer.getAttribute('data-variant-id');
    if (!variantId) return;

    var productEl = offer.closest('product-info') || offer.closest('.product');
    if (!productEl) return;

    var idInput = productEl.querySelector('input[name="id"].product-variant-id') ||
                  productEl.querySelector('input[name="id"]');
    if (!idInput) return;

    if (idInput.value !== variantId) {
      idInput.value = variantId;
      idInput.removeAttribute('disabled');
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initOffers(root) {
    (root || document).querySelectorAll('[data-drl-offer]').forEach(function (offer) {
      if (offer.dataset.drlBound) return;
      offer.dataset.drlBound = '1';
      offer.addEventListener('click', function (e) {
        e.preventDefault();
        selectOffer(offer);
      });
    });

    // Sync the form on init with whichever card is already marked selected.
    (root || document).querySelectorAll('[data-drl-offers]').forEach(function (group) {
      var sel = group.querySelector('.drl-offer--selected[data-variant-id]');
      if (sel) selectOffer(sel);
    });
  }

  // === MULTI-AXIS: pill row swaps card price/variant per active pill ===
  function initPillRow(root) {
    (root || document).querySelectorAll('.drl-offers__pills').forEach(function (pillRow) {
      if (pillRow.dataset.drlPillBound) return;
      pillRow.dataset.drlPillBound = '1';

      var dataEl = (pillRow.parentElement || document).querySelector('[data-drl-variant-data]') ||
                   document.querySelector('[data-drl-variant-data]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var pillAxis = parseInt(pillRow.dataset.drlPillAxis, 10) || 1; // 1 or 2 (which option is pills)
      var savingsFmt = pillRow.dataset.drlSavingsFmt || 'Spórolj {savings}';
      var cards = pillRow.parentElement.querySelectorAll('[data-drl-offer][data-card-option-value]');

      pillRow.querySelectorAll('.drl-offer-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var newPillVal = pill.dataset.drlPillValue;

          pillRow.querySelectorAll('.drl-offer-pill').forEach(function (p) {
            p.classList.remove('drl-offer-pill--active');
          });
          pill.classList.add('drl-offer-pill--active');

          cards.forEach(function (card) {
            var cardVal = card.dataset.cardOptionValue;
            var matched = null;
            for (var i = 0; i < variants.length; i++) {
              var v = variants[i];
              if (pillAxis === 1 && v.option1 === newPillVal && v.option2 === cardVal) { matched = v; break; }
              if (pillAxis === 2 && v.option2 === newPillVal && v.option1 === cardVal) { matched = v; break; }
            }
            if (!matched) return;

            card.dataset.variantId = matched.id;

            var priceEl = card.querySelector('[data-drl-price]');
            if (priceEl) priceEl.textContent = matched.priceFormatted;

            var oldEl = card.querySelector('[data-drl-price-old]');
            if (oldEl) {
              if (matched.comparePriceFormatted) {
                oldEl.textContent = matched.comparePriceFormatted;
                oldEl.removeAttribute('hidden');
              } else {
                oldEl.setAttribute('hidden', '');
              }
            }

            var savEl = card.querySelector('[data-drl-savings]');
            if (savEl) {
              if (matched.savingsFormatted) {
                var text = savingsFmt
                  .replace('{savings}', matched.savingsFormatted)
                  .replace('{price}', matched.priceFormatted)
                  .replace('{compare_at}', matched.comparePriceFormatted);
                savEl.textContent = text;
                savEl.removeAttribute('hidden');
              } else {
                savEl.setAttribute('hidden', '');
              }
            }

            var soldOut = card.querySelector('[data-drl-sold-out]');
            if (matched.available) {
              card.classList.remove('drl-offer--unavailable');
              if (soldOut) soldOut.setAttribute('hidden', '');
            } else {
              card.classList.add('drl-offer--unavailable');
              if (soldOut) soldOut.removeAttribute('hidden');
            }
          });

          // If the currently selected card became unavailable, hop to first available.
          var selected = pillRow.parentElement.querySelector('.drl-offer--selected');
          if (selected && selected.classList.contains('drl-offer--unavailable')) {
            var firstOk = pillRow.parentElement.querySelector('.drl-offer:not(.drl-offer--unavailable)');
            if (firstOk) firstOk.click();
          } else if (selected) {
            // Keep selection but sync the form's variant-id input to the (possibly new) variant ID.
            selectOffer(selected);
          }
        });
      });
    });
  }

  function initAll(root) {
    initOffers(root);
    initPillRow(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-bind after Shopify re-renders the block.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
